export const ROUTE_HOME = '/';
export const ROUTE_SUPPLIERS = '/suppliers';
export const ROUTE_SUPPLIERS_DASHBOARD = (uuid: string) =>
  `/suppliers/${uuid}/audit-cases-dashboard`;
export const ROUTE_AUDIT_CASES = '/audit-cases';
export const ROUTE_AUDIT_CASE = (uuid: string) => `/audit-cases/${uuid}`;
